import React from "react";

function PrivacyPolicy() {
  return (
    <div className="container grand_parent_div_text">
      <h2>Privacy Policy</h2>
      <p>
        Thank you for visiting mmonft.gallery We give utmost importance to your
        privacy. Let us brief you in detail of our privacy policies. We may
        collect from your when you visiting MMO NFT Market website or run
        through our products, features, materials and services. The policies do
        describe in detail on our procedures of how we collect use maintain,
        protect and disclose the information.
      </p>
      <p>
        The policy does apply for the information we collect on the website when
        one uses our services, which includes the activity of use registering
        for an account and further communication within MMO NFT Marketplace and
        the user. It includes all kind of communication through email, text and
        other electronic images.
      </p>
      <p>
        This Policy applies to information we collect on the Website and through
        your use of the Services generally (including when you register for an
        account), and through communications between you and the Website
        (including email, text, and other electronic messages).
      </p>
      <p>
        This Policy does not apply to information collected by third parties,
        including any websites, services, and applications that you elect to
        access through the Services. [It also does not apply to any information
        collected by the Company offline or through any other means, including
        any other website operated by us or any third party (including our
        affiliates and subsidiaries).]
      </p>
      <p>
        Please review this Policy carefully. By accessing or using the Services
        (or by clicking on “accept” or “agree” to this Policy when prompted),
        you agree to the terms of this Policy on behalf of yourself or the
        entity or organization that you represent. If you do not agree to any
        term in this Policy, you should refrain from further use of our
        Services.
      </p>
      <h3>1. Children Using or Accessing the Services.</h3>
      <p>
        The Services and its content are not intended for, nor directed at,
        children under the age of thirteen (13). No one under the age of
        thirteen (13) may provide any personal information to or on the
        Services. Please note that we do not knowingly collect any personally
        identifiable information from children under the age of thirteen (13).
        If you are under the age of thirteen (13), please do not attempt to use
        or register for the Services or send any information about yourself to
        us, including your name, address, telephone number, or email address.
      </p>
      <h3>2. Changes to Our Privacy Policy.</h3>
      <p>
        This Policy was last revised on the date noted at the top of this page.
        We may update this Policy from time to time Your continued use of the
        Services after we make changes is deemed to be acceptance of those
        changes, so please check the Policy periodically for updates.
      </p>
      <h3>3. Information We Collect.</h3>
      <p>
        We receive several types information about you from various sources,
        including (A) information and content that you give us; (B)
        automatically collected information; [and] (C) demographic information
        or other aggregate information [; and (D) information from other sources
      </p>
      <h3>How We Use Your Information.</h3>
      <p>
        We may use the information we collect about you in a variety of ways,
        including to:
      </p>
      <li>(i) provide the Services and its content to you;</li>{" "}
      <li>
        (ii) respond to comments and questions, and provide customer service;
      </li>
      <li>
        (iii) fulfill any other purpose for which you provide such information;
      </li>
      <li>
        (iv) communicate with you about your order, purchase, account, or
        subscription;
      </li>
      <li>
        (v) inform you about important changes to, or other news about, the
        Services or any of its features or content;
      </li>
      <li>
        (vi) operate, maintain, improve, personalize, and analyze the Services;
      </li>
      <li>
        (vii) monitor and analyze trends, usage, and activities for marketing or
        advertising purposes;
      </li>
      <li>
        (viii) detect, prevent, or investigate security breaches, fraud, and
        other unauthorized or illegal activity;
      </li>
      <li>
        (ix) carry out our obligations and enforce our rights arising from any
        contracts entered into between you and us, including for billing and
        collection;
      </li>
      <li>
        (x) maintain appropriate records for internal administrative purposes;
      </li>
      <li>
        [(xi) allow you to participate in interactive features on the Services;]
      </li>
      <li>
        (xii) send promotional communications, such as information about
        features, newsletters, offers, promotions, contests, and events;
      </li>
      <li>
        (xiii) share information across the Company's products and devices to
        provide a more tailored and consistent experience on all Company
        products you use;
      </li>
      <li>
        (xiv) develop, test and improve new products or services, including by
        conducting surveys and research, and testing and troubleshooting new
        products and features;
      </li>
      <h3>5. How We Share Your Information.</h3>
      <p>
        We may disclose aggregated or anonymized information about our users
        without any restrictions. We will not share your personal information
        that we collect or you provide as described in this Policy except in the
        following circumstances:{" "}
      </p>
      <h3> 6. Your Choices.</h3>
      <h4>6.1 Mechanisms to Control Your Information. </h4>
      <p>
        We strive to provide you with choices regarding the personal information
        you provide to us. We have created mechanisms to provide you with the
        following control over your information:
      </p>
      <h3>7. Accessing and Correcting Your Information.</h3>
      <p>
        You may send us an email to request access to, correct, or remove any
        personal information that you have provided to us. You may also access,
        correct, or remove your personal information by logging into the Website
        and visiting your account profile page. [If you delete your User Content
        from the Services or your account, copies of your User Content may
        remain viewable in cached and archived pages, or might have been copied
        or stored by other users of the Services.]
      </p>
      <h3>8. How We Protect Your Information.</h3>
      <p>
        We have implemented technical, physical, and administrative security
        measures designed to reduce the risk of loss, misuse, unauthorized
        access, disclosure, or modification of your information. All information
        you provide to us is stored on our secure servers behind firewalls. When
        you transmit highly sensitive information (such as a credit card number)
        through the Services, we encrypt the transmission of that information
        using Secure Sockets Layer (SSL) technology.] The safety and security of
        your information also depend on you. We ask you not to share your
        password with anyone. While we have employed security technologies and
        procedures to assist safeguarding your personal information, no system
        or network can be guaranteed to be 100% secure. Unauthorized entry or
        use, hardware or software failure, and other factors may compromise the
        security of user information at any time. Any transmission of personal
        information is at your own risk. We are not responsible for
        circumvention of any privacy settings or security measures contained on
        the Website or any other Services.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
